import { deleteHistoryEntry } from "../../api/historyService";

export const useDeleteHistoryEntry = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteHistoryEntry(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete history:", error);
            throw error;
        }
    };

    return { remove };
};